import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

interface DiscountData {
  percentage_discount_name?: string;
  percentage_discount?: number;
  fixed_price_discount_name?: string;
  fixed_price_discount?: number;
  type?: number;
}
export const defaultPosOrderCustomDiscount = { type: 1 };

const posOrderCustomDiscountAtom = atomWithStorage<DiscountData>(
  "posOrderCustomDiscount",
  defaultPosOrderCustomDiscount
);

const usePosOrderCustomDiscount = () => {
  const atom = useAtom(posOrderCustomDiscountAtom);
  return atom;
};

export const useSetPosOrderCustomDiscount = () =>
  useSetAtom(posOrderCustomDiscountAtom);

export default usePosOrderCustomDiscount;
